<template>
  <el-dialog
    title="提示"
    :visible.sync="isShow"
    width="480px"
    custom-class="UpgradeDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
  >
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">
          <img :src="$utils.getPng('web4/icon-circle-fill')" />
          <span>提示</span>
        </div>
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div class="d-content">
        <p class="title">
          下载券数量不足
          <el-tooltip placement="right-start" :offset="-10">
            <div slot="content" style="max-width: 195px; line-height: 18px">
              下载券有效期：使用下载券时将优先使用即将到期的下载券。<br /><span
                class="pointer"
                style="text-decoration: underline"
                @click="isVolumeFn"
                >去查看下载券明细</span
              >
            </div>
            <svg-btn
              class="question"
              icon-class="icon_question_circle"
            ></svg-btn>
          </el-tooltip>
        </p>
        <p class="txt">您可通过引荐计划邀请新用户获得下载券</p>
      </div>
      <div class="d-footer">
        <fm-button type="primary" size="small" @click="govip"
          >去获得下载券</fm-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "title",
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    isVolumeFn(){
      this.$emit("Volume");
    },
    handleClose() {
      this.$emit("handleClose");
    },
    govip() {
      this.$emit("routeMode");
    },
  },
};
</script>

<style lang="scss" scoped>
.question {
  color: #bdbdbe;
  height: 16px !important;
  width: 16px !important;
  margin-left: 4px;
  cursor: pointer;
}
.UpgradeDialog {
  .title {
    margin-top: 32px;
    margin-bottom: 0px;
    text-align: center;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      color: #f67942;
    }
  }
  .txt {
    line-height: 22px;
    margin-top: 12px;
    margin-bottom: 24px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .d-footer {
    .is-plain {
      margin-left: 12px;
    }
  }
}
</style>